import { useNavigate } from 'react-router-dom'
import { Button, Stack, Tile } from '@carbon/react'
import type { CarbonIconType } from '@carbon/icons-react'
import styles from './AiDashboardCard.module.scss'
import { ArrowRight } from '@carbon/icons-react'
export interface AiDashboardCardProps {
  id: string
  title: string
  description: string
  icon: CarbonIconType
  color: 'purple' | 'green' | 'blue' | 'orange' | 'indigo'
  path: string
  estimatedTime: string
  features?: readonly string[]
  available?: boolean
}

const COLOR_MAP = {
  purple: {
    bg: 'rgba(105, 41, 196, 0.1)',
    icon: '#6929c4',
    border: 'rgba(105, 41, 196, 0.2)',
  },
  green: {
    bg: 'rgba(14, 96, 39, 0.1)',
    icon: '#0e6027',
    border: 'rgba(14, 96, 39, 0.2)',
  },
  blue: {
    bg: 'rgba(15, 98, 254, 0.1)',
    icon: '#0f62fe',
    border: 'rgba(15, 98, 254, 0.2)',
  },
  orange: {
    bg: 'rgba(255, 131, 43, 0.1)',
    icon: '#ff832b',
    border: 'rgba(255, 131, 43, 0.2)',
  },
  indigo: {
    bg: 'rgba(138, 63, 252, 0.1)',
    icon: '#8a3ffc',
    border: 'rgba(138, 63, 252, 0.2)',
  },
} as const

export function AiDashboardCard({
  id,
  title,
  description,
  icon: Icon,
  color,
  path,
  estimatedTime,
  available = true,
}: AiDashboardCardProps) {
  const navigate = useNavigate()
  const content = (
    <Stack gap={5} className={styles.content}>
      <Stack gap={3} orientation="horizontal" className={styles.header}>
        <div className={styles.iconContainer}>
          <Icon size={24} />
        </div>
        <div className={styles.titleBlock}>
          <h3 className={styles.title}>{title}</h3>
          <span className={styles.estimatedTime}>{estimatedTime}</span>
        </div>
      </Stack>

      <p className={styles.description}>{description}</p>

      <Button
        disabled={!available}
        kind="primary"
        renderIcon={ArrowRight}
        className={styles.actionButton}
        onClick={() => available && navigate(path)}
      >
        Commencer
      </Button>
    </Stack>
  )

  return <Tile className={styles.card}>{content}</Tile>
}
